import { RouteType } from '@/main/menu/constants';

import { UzivatelskyProfil } from './uzivatelskyProfil';
import { NastaveniExportu } from './nastaveniExportu';
import { NastaveniUpozornovani } from './nastaveniUpozornovani';
import { NastaveniTisku } from './nastaveniTisku';
import { WatchlistApproval } from './watchlistApproval';
import { OrganizacniJednotky } from './organizacniJednotky';
import { Pracovnik } from './pracovnik';
import{NewCdbLog}  from './newCdbLog';

export const menu = {
	name: 'pAdministrace',
	orderAlphabetically: false,
	list: [
		{ name: 'ADM_Aplikace', route: 'OAplikaci', routeType: RouteType.name, delimited: true },

		{ name: 'UzivProfil', route: UzivatelskyProfil.name },
		{ name: 'Pracovnik', route: Pracovnik.name },
		{ name: 'ADM_Heslo', route: 'ZmenaHesla', routeType: RouteType.name },
		{ name: 'ADM_Pole', route: 'UserDefColumns' },
		{ name: 'ADM_NastaveniUpozornovani', route: NastaveniUpozornovani.name },
		{ name: 'NastaveniTisku', route: NastaveniTisku.name, delimited: true },

		{ name: 'Organizace', route: 'Organizace', routeType: RouteType.name },
		{ name: 'FirmaSidlo', route: 'SidloFirmy' },
		{ name: 'Provozovna', route: 'Provozovna' },
		{ name: 'OrganizacniJednotky', route: OrganizacniJednotky.name, delimited: true },
		{ name: 'WatchlistApproval', route: WatchlistApproval.name },

		{ name: 'ADM_ChybovyLog', route: 'ChybovyLog' },
		{ name: 'ADM_SqlLog', route: 'SqlLog', routeType: RouteType.name },
		{ name: 'ADM_CdbLog', route: 'CdbLog' },
		{ name: 'NewCdbLog', route: NewCdbLog.name },
		{ name: 'LogSystemUdalosti', route: 'LogSystemUdalosti', delimited: true },

		{ name: 'pEDIMap', route: 'ElektronickaFakturace' },
		{ name: 'HaleroveVyrovnani', route: 'HalerVyrov' },
		{ name: 'LimityCiselnychRad', route: 'LimCisRad', delimited: true },

		{ name: 'ADM_NastaveniExportu', route: NastaveniExportu.name },
		{ name: 'ADM_CaskPredplatne', route: 'CaskPredplatne', delimited: true },

		{ name: 'MobilniZarizeni', route: 'MobilniZarizeni', delimited: true },
	],
};
